import React from 'react';
import { render } from '@testing-library/react';
import { Table, TableColumn } from '.';

describe('Table', () => {
	it('displayName should be equal to "KendoReactGrid"', () => {
		// PDF export has some internal comparisons with displayName
		expect(Table.displayName).toBe('KendoReactGrid');
	});

	it.skip('should pass through data automation attributes', () => {
		const sampleProducts = [
			{
				ProductID: 1,
				ProductName: 'Chai',
				SupplierID: 1,
				CategoryID: 1,
				QuantityPerUnit: '10 boxes x 20 bags',
				UnitPrice: 18,
				UnitsInStock: 39,
				UnitsOnOrder: 0,
				ReorderLevel: 10,
				Discontinued: false,
				Category: {
					CategoryID: 1,
					CategoryName: 'Beverages',
					Description: 'Soft drinks, coffees, teas, beers, and ales',
				},
				FirstOrderedOn: new Date(1996, 8, 20),
			},
		];

		const { container } = render(
			<Table data={sampleProducts} data-auto-sel="automation-selector">
				<TableColumn field="ProductID" title="ID" width="50px" />
				<TableColumn field="ProductName" title="Name" width="300px" />
				<TableColumn field="Category.CategoryName" title="Category" />
				<TableColumn
					headerClassName="ta-right"
					className="ta-right"
					field="UnitPrice"
					title="Price"
					format="{0:c}"
				/>
				<TableColumn field="UnitsInStock" title="In stock" />
				<TableColumn field="Discontinued" title="Discontinued" />
			</Table>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it.skip('should pass through data automation attributes', () => {
		const sampleProducts = [
			{
				ProductID: 1,
				ProductName: 'Chai',
				SupplierID: 1,
				CategoryID: 1,
				QuantityPerUnit: '10 boxes x 20 bags',
				UnitPrice: 18,
				UnitsInStock: 39,
				UnitsOnOrder: 0,
				ReorderLevel: 10,
				Discontinued: false,
				Category: {
					CategoryID: 1,
					CategoryName: 'Beverages',
					Description: 'Soft drinks, coffees, teas, beers, and ales',
				},
				FirstOrderedOn: new Date(1996, 8, 20),
			},
		];

		const { container } = render(
			<Table data={sampleProducts}>
				<TableColumn
					field="ProductID"
					title="ID"
					width="50px"
					data-auto-sel="automation-selector"
				/>
				<TableColumn field="ProductName" title="Name" width="300px" />
				<TableColumn field="Category.CategoryName" title="Category" />
				<TableColumn
					headerClassName="ta-right"
					className="ta-right"
					field="UnitPrice"
					title="Price"
					format="{0:c}"
				/>
				<TableColumn field="UnitsInStock" title="In stock" />
				<TableColumn field="Discontinued" title="Discontinued" />
			</Table>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
